import tlds from 'tlds';

// без плюса в локальной части
export const EMAIL_REGEX
  = /^[A-Za-z0-9](?:[\w-]*[A-Za-z0-9])?(?:\.[A-Za-z0-9](?:[\w-]*[A-Za-z0-9])?)*@(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z]{2,99}$/i;

export const SANDBOX_EMAIL_REGEX
  = /^[A-Za-z0-9+](?:[\w+-]*[A-Za-z0-9+])?(?:\.[A-Za-z0-9+](?:[\w+-]*[A-Za-z0-9+])?)*@(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z]{2,99}$/i;

interface UseEmailValidationReturn {
  checkEmailFormat: (email: string) => boolean;
  checkDomainExists: (email: string) => Promise<boolean>;
}

async function checkDomainExists(email: string): Promise<boolean> {
  const domainPart = email?.split('@')[1];

  if (!domainPart) {
    return false;
  }

  const parts = domainPart.split('.');
  const tld = parts.at(-1);

  return tld ? tlds.includes(tld.toLowerCase()) : false;
}

export function useEmailValidation(): UseEmailValidationReturn {
  const { ENVIRONMENT } = useRuntimeConfig().public;

  function checkEmailFormat(email: string): boolean {
    if (ENVIRONMENT === 'development') {
      return SANDBOX_EMAIL_REGEX.test(email);
    }
    return EMAIL_REGEX.test(email);
  }

  return {
    checkEmailFormat,
    checkDomainExists,
  };
}
